import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThankyouPageTipComponent } from './thankyou-page-tip.component';
import { SharedModule } from '../../shared/shared.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { ThankyouSuccessHeadModule } from '../thankyou-success-head/thankyou-success-head.module';
import { PaymentOtdModule } from '../payment-otd/payment-otd.module';



@NgModule({
  declarations: [ThankyouPageTipComponent],
  imports: [
    CommonModule,
    SharedModule,
    ModuleLoaderModule,
    ThankyouSuccessHeadModule,
    PaymentOtdModule
  ],
  exports: [ThankyouPageTipComponent],
  bootstrap: [ThankyouPageTipComponent]
})
export class ThankyouPageTipModule {
  getComponent() {
    return ThankyouPageTipComponent;
  }
}
